import React from 'react';
import dayjs from 'dayjs';
import { Grid, MenuItem } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import {
  NewMainWidgetDatePicker,
  IconedBox,
} from 'views/rebranded-module/common/components/UI/NewMainWidget';
import {
  LOCATION_TYPE,
  RENTAL_WIDGET_FIELDS,
  ERRORS_PREFIX,
} from 'lib/utils/mainWidgetConstants';
import isBetween from 'dayjs/plugin/isBetween';
import StyledGrid, {
  SelectMainWidgetTextField,
} from 'views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetDateTimeField/NewWidgetDateTimeField.styles';

dayjs.extend(isBetween);

const NewWidgetDateTimeField = (props) => {
  const {
    pickup,
    vertical,
    date,
    handleDateTimeChange,
    time,
    timeList = [],
    dataLabel,
    timeLabel,
    minDate,
    maxDate,
    shouldDisableDate,
    errors,
    disabled,
    openWidgetDateTimeField,
    resetOpenWidgetDateTimeField,
    whiteLabelWidget,
  } = props;
  const getDateFieldType = () => (pickup === LOCATION_TYPE.PICKUP
    ? RENTAL_WIDGET_FIELDS.PICKUP_DATE
    : RENTAL_WIDGET_FIELDS.DROPOFF_DATE);

  const getTimeSlotsFieldType = () => (pickup === LOCATION_TYPE.PICKUP
    ? RENTAL_WIDGET_FIELDS.PICKUP_TIME_SLOT
    : RENTAL_WIDGET_FIELDS.DROPOFF_TIME_SLOT);

  return (
    <StyledGrid
      container
      bordered={vertical}
      error={!!errors[`${ERRORS_PREFIX}${getDateFieldType()}`]}
      spacing={0}>
      <Grid
        className="WidgetDateField"
        item
        xs={6}
        sm={7}
        lg={vertical ? 7 : 8}>
        <IconedBox
          className="WDTFDate"
          Icon={DateRangeIcon}
          disabled={disabled}
          error={!!errors[`${ERRORS_PREFIX}${getDateFieldType()}`]}>
          <NewMainWidgetDatePicker
            label={dataLabel}
            value={dayjs(date || null)}
            fieldType={getDateFieldType()}
            onChange={(value) => {
              if (
                value
                && !dayjs(date).isSame(value)
                && !shouldDisableDate(pickup, value)
                && dayjs(value).isBetween(
                  dayjs(minDate),
                  dayjs(maxDate),
                  'day',
                  '[]',
                )
              ) {
                handleDateTimeChange(getDateFieldType(), value);
              }
            }}
            minDate={dayjs(minDate)}
            maxDate={dayjs(maxDate)}
            bordered={vertical}
            // eslint-disable-next-line no-shadow
            shouldDisableDate={(date) => shouldDisableDate(pickup, date)}
            id={`${ERRORS_PREFIX}${getDateFieldType()}`}
            error={!!errors[`${ERRORS_PREFIX}${getDateFieldType()}`]}
            disabled={disabled}
            openMainWidgetDatePicker={openWidgetDateTimeField}
            resetOpenWidgetDateTimeField={resetOpenWidgetDateTimeField}
            whiteLabelWidget={whiteLabelWidget}
          />
        </IconedBox>
      </Grid>
      <Grid item xs={6} sm={5} lg={vertical ? 5 : 4}>
        <IconedBox
          className="WDTFTime"
          error={!!errors[`${ERRORS_PREFIX}${getTimeSlotsFieldType()}`]}>
          <SelectMainWidgetTextField
            label={timeLabel}
            InputLabelProps={{ shrink: true }}
            select
            fullWidth
            id={`${ERRORS_PREFIX}${getTimeSlotsFieldType()}`}
            SelectProps={{
              SelectDisplayProps: {
                'data-testid': `${ERRORS_PREFIX}${getTimeSlotsFieldType()}`,
              },
            }}
            error={!!errors[`${ERRORS_PREFIX}${getDateFieldType()}`]}
            value={time || ''}
            onChange={(e) => handleDateTimeChange(getTimeSlotsFieldType(), e.target.value)}
            variant="filled"
            disabled={disabled}
            className="WidgetInput">
            {timeList.map((option) => (
              <MenuItem
                key={option}
                value={option}
                data-testid="time-slot-option"
                sx={{ textTransform: 'uppercase' }}>
                {option}
              </MenuItem>
            ))}
          </SelectMainWidgetTextField>
        </IconedBox>
      </Grid>
    </StyledGrid>
  );
};

export { NewWidgetDateTimeField };